import React, { Component } from 'react'

export class ContactUs extends Component {
  render() {
    return (
      <div>ContactUs</div>
    )
  }
}

export default ContactUs